import {
  ACTION_GET_CUSTOM_FIELDS,
  ACTION_GET_CUSTOM_FIELDS_SUCCESS,
  ACTION_GET_CUSTOM_FIELDS_FAILURE,
} from '../configs/ActionTypes';

const initialState = {
  fields: [],
  isLoading: false,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_CUSTOM_FIELDS: {
      return { ...state, isLoading: true };
    }
    case ACTION_GET_CUSTOM_FIELDS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        fields: action.payload.payload ?? [],
        success: true,
      };
    }
    case ACTION_GET_CUSTOM_FIELDS_FAILURE: {
      return { ...state, isLoading: false, success: false };
    }
    default: {
      return state;
    }
  }
}
